import CrudCustom from '../../../libs/custom/CrudCustom';

let PengurangService = new CrudCustom('/pengurang-ph-brutos');
export default PengurangService;
